export enum UserAnalyticsTrackerType {
    FIRST_ELEMENT_CREATION = 'firstElementCreation',
    THIRD_ELEMENT_CREATION = 'thirdElementCreation',
    FIRST_IMAGE_CREATION = 'firstImageCreation',
}

export type MNUserAnalyticsTrackerState = {
    elementCreationCount?: number;
};

export type MNUserAnalyticsDocument = {
    userId: string;
    trackerType: UserAnalyticsTrackerType;
    createdAt: number;
    updatedAt: number;
    state?: MNUserAnalyticsTrackerState;
    _id?: string;
    __v?: number;
};

export type MNUserAnalytics = Partial<Record<UserAnalyticsTrackerType, MNUserAnalyticsDocument>>;
